<template>
  <div class="treeMain" id="treeMain" :class="{ 'is-light': isLight }">
    <div class="site-panel-wrapper" v-if="visiable">
      <border class="site-tree" :width="width" percentHeight="100%" top="0" background="transparent">
        <div class="project-box">
          <div class="content">
            <div class="box">
            <!-- 头部维度与类型切换区 -->
            <div class="tree-header">
              <!-- 业务维度切换 (区域/流域/管网 或 行业分类) -->
              <div class="header-dimension-row">
                <!-- 场景 1: all 与 showArea 均开启，支持「区域 / 流域 / 管网」三者切换 -->
                <a-radio-group
                  v-if="all && showArea"
                  v-model="value"
                  @change="onChange"
                  button-style="solid"
                  size="small"
                >
                  <a-radio-button value="1">区域</a-radio-button>
                  <a-radio-button value="2">流域</a-radio-button>
                  <a-radio-button value="3">管网</a-radio-button>
                </a-radio-group>

                <!-- 场景 2: 仅开启 all，支持「区域 / 管网」切换 (如派工单模式) -->
                <a-radio-group
                  v-else-if="all"
                  v-model="value"
                  @change="onChange"
                  button-style="solid"
                  size="small"
                >
                  <a-radio-button value="1">区域</a-radio-button>
                  <a-radio-button value="3">管网</a-radio-button>
                </a-radio-group>

                <!-- 场景 3: 开启 showArea 或全局监测站点类型多于2种，支持「区域 / 流域」切换 -->
                <a-radio-group
                  v-else-if="showArea || stList.length > 2"
                  v-model="value"
                  @change="onChange"
                  button-style="solid"
                  size="small"
                >
                  <a-radio-button value="1">区域</a-radio-button>
                  <a-radio-button value="2">流域</a-radio-button>
                </a-radio-group>

                <!-- 场景 4: 行业分类切换 -->
                <a-radio-group
                  v-else-if="categoryList && categoryList.length > 0"
                  v-model="category"
                  @change="onCategoryChange"
                  button-style="solid"
                  size="small"
                >
                  <a-radio-button v-for="item in categoryList" :key="item.value" :value="item.value">
                    {{ item.title }}
                  </a-radio-button>
                </a-radio-group>

                <!-- 明确易懂的全部展开/全部折叠/收起面板文本链接 -->
                <div class="tree-action-links">
                  <span class="action-link" @click="handleExpandAll" title="展开所有分组节点">全部展开</span>
                  <span class="action-divider">|</span>
                  <span class="action-link" @click="handleCollapseAll" title="收起所有分组节点">全部折叠</span>
                  <span class="action-divider">|</span>
                  <span class="action-link close-link" @click="close" title="收起站点树">
                    <a-icon type="menu-fold" style="font-size: 11px; margin-right: 2px" />收起
                  </span>
                </div>
              </div>

              <!-- 站点类型下拉选择 (废气/废水/水质等) -->
              <div class="header-type-row" v-if="stList.length > 2">
                <a-select
                  style="width: 100%"
                  v-model="st"
                  placeholder="请选择监测站点类型"
                  size="small"
                  @change="typeChange"
                  :filterOption="filterOption"
                  showSearch
                >
                  <a-select-option v-for="(item, i) in stList" :key="i" :value="item.value">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </div>

              <!-- 智能搜索栏 -->
              <div class="header-search-row">
                <a-input
                  ref="searchInput"
                  v-model="filterText"
                  placeholder="搜索站点名称、区域、拼音、MN号..."
                  size="small"
                  allowClear
                  @change="handleSearchInput"
                >
                  <a-icon slot="prefix" type="search" style="color: #64b5f6" />
                </a-input>
              </div>

              <!-- 多选模式下的操作统计栏 -->
              <div v-if="showCheckbox" class="header-checkbox-toolbar">
                <span class="selected-count">已选: {{ checkedKeys.length }} 站</span>
                <div class="checkbox-btns">
                  <a-button type="link" size="small" @click="handleSelectAllCurrent">全选当前</a-button>
                  <a-button type="link" size="small" @click="handleClearChecked">清空</a-button>
                </div>
              </div>
            </div>

            <!-- 中间主体区域：左侧区域导引轨 + 右侧虚拟滚动视口 -->
            <div class="tree-body-wrapper">
              <!-- 左侧区域导引栏 (无“速达”文本，简洁纵向导航条，非搜索状态下显示) -->
              <div v-if="!isSearching && regionIndex.length > 0" class="tree-regions-sidebar">
                <div class="regions-sidebar-list">
                  <div
                    class="region-sidebar-item"
                    :class="{ active: activeRegionId === null }"
                    @click="handleJumpRegion(null)"
                    title="回到顶部"
                  >
                    顶部
                  </div>
                  <div
                    v-for="reg in regionIndex"
                    :key="reg.id"
                    class="region-sidebar-item"
                    :class="{ active: activeRegionId === reg.id }"
                    @click="handleJumpRegion(reg)"
                    :title="reg.label"
                  >
                    {{ reg.label }}
                  </div>
                </div>
              </div>

              <!-- 右侧主体内容区：树顶常驻常用分组 + 虚拟滚动列表 -->
              <div class="tree-main-content">
                <!-- 树顶常驻常用与收藏独立分组 -->
                <div
                  v-if="!isSearching && quickSites.length > 0"
                  class="pinned-quick-group"
                  :class="{ 'is-collapsed': quickGroupCollapsed }"
                >
                  <div class="quick-group-header" @click="toggleQuickGroup">
                    <div class="header-left">
                      <span class="expander-icon">
                        <a-icon :type="quickGroupCollapsed ? 'caret-right' : 'caret-down'" />
                      </span>
                      <a-icon type="star" theme="filled" class="star-icon" />
                      <span class="group-title">常用与收藏</span>
                      <span class="group-count">({{ quickSites.length }})</span>
                    </div>
                    <div class="header-right">
                      <span class="collapse-hint">{{ quickGroupCollapsed ? '展开' : '收起' }}</span>
                    </div>
                  </div>

                  <!-- 展开状态下展示常用站点垂直列表 (全称展示、零截断、无横向滚动条) -->
                  <div v-show="!quickGroupCollapsed" class="quick-site-list">
                    <div
                      v-for="item in quickSites"
                      :key="item.key"
                      class="quick-site-item"
                      :class="{
                        'is-active': currentKey === item.key,
                        'is-disabled': item.disabled
                      }"
                      @click="handleSelectQuickSite(item)"
                      :title="getRowTooltip(item)"
                    >
                      <span class="item-status-icon">
                        <i
                          class="site-online-dot"
                          :class="item.online ? 'online' : 'offline'"
                          :title="item.online ? '在线' : '离线'"
                        />
                      </span>

                      <span class="item-name">{{ item.label }}</span>

                      <div class="item-badges">
                        <span
                          v-if="item.currentStandard"
                          class="status-tag standard"
                          :style="{
                            backgroundColor: item.currentStandard.color || '#1890ff',
                            color: getBadgeTextColor(item.currentStandard.color)
                          }"
                        >
                          {{ item.currentStandard.title }}
                        </span>
                        <span
                          v-else-if="item.upStandard === 'true'"
                          class="status-tag up-standard"
                        >
                          达标
                        </span>
                        <span
                          v-else-if="item.upStandard === 'false'"
                          class="status-tag over-standard"
                        >
                          超标
                        </span>
                      </div>

                      <div class="item-actions" @click.stop>
                        <a-tooltip title="取消收藏" v-if="isFavorite(item.key)">
                          <a-icon
                            type="star"
                            theme="filled"
                            class="action-star active"
                            @click="toggleFavorite(item)"
                          />
                        </a-tooltip>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 右侧虚拟滚动容器 -->
                <div
                  class="tree-virtual-viewport"
                  ref="viewport"
                  @scroll="handleScroll"
                >
                <!-- 正在加载状态 -->
                <div v-if="loading" class="tree-status-message">
                  <a-icon type="loading" style="font-size: 20px; color: #1890ff; margin-bottom: 8px" />
                  <span>正在加载监测站点…</span>
                </div>

                <!-- 空状态 -->
                <div v-else-if="!visibleTotal" class="tree-status-message">
                  <a-icon type="info-circle" style="font-size: 20px; color: #90a4ae; margin-bottom: 8px" />
                  <span>{{ isSearching ? '未找到匹配的站点或区域' : '当前筛选条件下暂无站点' }}</span>
                  <a-button v-if="filterText" type="link" size="small" @click="filterText = ''">
                    清空搜索
                  </a-button>
                </div>

                <!-- 虚拟列表视口内容 -->
                <div
                  v-else
                  class="virtual-space"
                  :style="{ height: virtualTotalHeight + 'px' }"
                >
                  <div
                    class="virtual-window"
                    :style="{ transform: 'translateY(' + virtualWindow.topSpace + 'px)' }"
                  >
                    <div
                      v-for="row in virtualWindow.rows"
                      :key="row.id"
                      class="virtual-row"
                      :class="{
                        'is-active': currentKey === row.key,
                        'is-group': !row.isSite,
                        'is-site': row.isSite,
                        'is-root-group': !row.isSite && row.level === 0,
                        'is-searching': isSearching,
                        'is-disabled': row.disabled
                      }"
                      :style="{
                        height: virtualWindow.rowHeight + 'px',
                        paddingLeft: getRowPaddingLeft(row)
                      }"
                      @click="handleRowClick(row)"
                    >
                      <!-- 折叠展开箭头 (仅在非搜索且为分组节点时渲染，彻底去除叶子站点空白占位) -->
                      <span
                        v-if="!isSearching && !row.isSite"
                        class="row-expander"
                        @click.stop="toggleCollapse(row)"
                      >
                        <a-icon
                          v-if="row.hasChildren"
                          :type="row.collapsed ? 'caret-right' : 'caret-down'"
                          style="font-size: 11px; color: #78909c"
                        />
                      </span>

                      <!-- 多选复选框 -->
                      <span v-if="showCheckbox" class="row-checkbox" @click.stop>
                        <a-checkbox
                          :checked="isChecked(row)"
                          :indeterminate="isIndeterminate(row)"
                          :disabled="row.disabled || (onlineSelect && row.isSite && !row.online)"
                          @change="toggleCheck(row)"
                        />
                      </span>

                      <!-- 图标标识: 站点类型 / 文件夹 -->
                      <span class="row-icon-box">
                        <!-- 站点状态微标圆点 (绿色在线 / 灰色离线) -->
                        <i
                          v-if="row.isSite"
                          class="site-online-dot"
                          :class="row.online ? 'online' : 'offline'"
                          :title="row.online ? '在线' : '离线'"
                        />
                        <!-- 分组文件夹图标 -->
                        <a-icon
                          v-if="!row.isSite"
                          :type="row.collapsed ? 'folder' : 'folder-open'"
                          style="color: #ffa726; font-size: 14px;"
                        />
                        <!-- 站点业务类型图标 (废气/废水/水质/土壤等) -->
                        <i
                          v-else
                          :class="['iconfont', getIconClass(row)]"
                          :style="{ color: row.online ? '#42a5f5' : '#78909c' }"
                        />
                      </span>

                      <!-- 行主体信息 (分词高亮 + 路径面包屑) -->
                      <div class="row-content-box" :title="getRowTooltip(row)">
                        <!-- 标题行 (分词高亮 + 站点数量固定不被挤压) -->
                        <div class="row-title">
                          <span class="row-name">
                            <span
                              v-for="(part, pIdx) in row.parts"
                              :key="pIdx"
                              :class="{ 'search-hit': part.hit }"
                            >{{ part.text }}</span>
                          </span>
                          <!-- 分组在线统计数 (flex-shrink: 0 保证超长区域名下仍完整可见) -->
                          <span v-if="!row.isSite && !isSearching" class="group-count">
                            ({{ row.onlineNum }}/{{ row.total }})
                          </span>
                        </div>

                        <!-- 搜索模式下的所属区域/企业路径提示 -->
                        <div v-if="isSearching" class="row-subpath">
                          {{ row.path || '监测站点' }}
                        </div>
                      </div>

                      <!-- 右侧状态徽章 (高对比度清晰文本与底色，Flex右对齐) -->
                      <div class="row-badges">
                        <!-- 环保水质类别或标准 (如 III类, IV类, 劣V类) -->
                        <span
                          v-if="row.currentStandard && row.isSite"
                          class="status-tag standard"
                          :style="{
                            backgroundColor: row.currentStandard.color || '#1890ff',
                            color: getBadgeTextColor(row.currentStandard.color)
                          }"
                        >
                          {{ row.currentStandard.title }}
                        </span>

                        <!-- 达标 / 不达标状态徽章 -->
                        <span
                          v-else-if="row.isSite && row.upStandard === 'true'"
                          class="status-tag up-standard"
                        >
                          达标
                        </span>
                        <span
                          v-else-if="row.isSite && row.upStandard === 'false'"
                          class="status-tag over-standard"
                        >
                          超标
                        </span>
                      </div>

                      <!-- 悬浮微操作栏 -->
                      <div class="row-hover-actions" @click.stop>
                        <!-- 收藏/取消收藏按钮 -->
                        <a-tooltip :title="isFavorite(row.key) ? '取消收藏' : '添加收藏'" v-if="row.isSite">
                          <a-icon
                            :type="isFavorite(row.key) ? 'star' : 'star'"
                            :theme="isFavorite(row.key) ? 'filled' : 'outlined'"
                            class="action-icon star-icon"
                            :class="{ active: isFavorite(row.key) }"
                            @click="toggleFavorite(row)"
                          />
                        </a-tooltip>

                        <!-- 分组选择范围按钮 (支持直接将某区域/企业选为业务筛选范围) -->
                        <span
                          v-if="isAreaSelectable && !row.isSite && !showCheckbox && !row.disabled"
                          class="group-select-btn"
                          :class="{ 'is-selected': currentKey === row.key }"
                          :title="currentKey === row.key ? '当前已选择该范围' : '将此区域设为业务筛选范围'"
                          @click.stop="handleSelectAreaScope(row)"
                        >
                          <a-icon type="aim" class="btn-icon" />{{ currentKey === row.key ? '当前范围' : '选为范围' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <!-- 底部常驻已选状态栏 -->
            <div class="tree-footer-bar">
              <div class="footer-selection-info" :title="currentFullName || currentSiteName">
                <span class="footer-label">当前选择：</span>
                <span class="footer-value">{{ currentSiteName || '未选择任何站点' }}</span>
              </div>
              <a-button
                v-if="currentKey"
                type="link"
                size="small"
                icon="aim"
                class="footer-locate-btn"
                @click="revealCurrentSite"
              >
                定位
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </border>

      <!-- 宽度调整拖拽线 -->
      <div class="resize-handle" @mousedown="startResize" title="按住拖拽调整侧栏宽度"></div>
    </div>

    <!-- 侧栏收起状态下的展开按钮 -->
    <div class="show-trigger" v-else @click="show" title="展开站点树">
      <a-icon type="caret-right" />
    </div>
  </div>
</template>

<script>
import { querySiteTree, ajaxGetDictItems, getTenantStByToken } from '@/api/api'
import border from '@/components/border/borderType'
import {
  flattenSiteTree,
  getSiteTreeIds,
  getSiteTreeWindow,
  getSiteRegionIndex,
  expandSiteBranch,
  expandNodeOnly,
  collapseAllGroups,
  expandAllGroups,
  findNodeByKey,
  getNodeBreadcrumbs,
} from '@/utils/site-tree-data'

export default {
  name: 'siteSelect',
  components: {
    border,
  },
  props: {
    showCheckbox: {
      default: false,
    },
    onlineSelect: {
      default: false,
    },
    // 维度类型: '1'=区域, '2'=流域, '3'=管网
    type: {
      type: [String, Number],
      default: '1',
    },
    // 是否开启区域/流域切换 (兼容 pipeNetwork.vue)
    showArea: {
      type: Boolean,
      default: false,
    },
    // 是否开启管网切换 (兼容 pipeNetwork.vue)
    all: {
      type: Boolean,
      default: false,
    },
    // 初始指定站点 ID (兼容巡检单/派工单运维跳转)
    initialSiteId: {
      type: [String, Number],
      default: null,
    },
    // 是否开启浅色主题模式 (为 null 时自动响应全局 $store.state.bgLight / localStorage)
    light: {
      type: Boolean,
      default: null,
    },
    // 是否允许选择区域作为业务筛选范围 (默认 true；大屏/档案等站点级页面设为 false，禁止选区域)
    allowSelectArea: {
      type: Boolean,
      default: true,
    },
    // 是否仅支持站点 (alias for allowSelectArea === false)
    siteOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visiable: true,
      category: '',
      categoryList: [],
      areaSelectedState: true,
      selectedState: false,
      _isSelfUpdating: false,
      _needReloadOnShow: false,
      st: '',
      value: this.type ? String(this.type) : '1',
      filterText: '',
      stList: [],
      loading: false,

      // 侧栏面板宽度控制 (默认 350px，兼顾左侧区域导引与右侧树节点)
      panelWidth: 350,
      width: '350',

      // 核心业务选中状态
      siteId: '',
      currentKey: '',
      currentSiteName: '',
      currentFullName: '',
      currentSiteType: '',
      checkedKeys: [],
      busSiteOnly: false,

      // 常用与收藏状态
      recentKeys: [],
      favoriteKeys: [],
      activeRegionId: null,
      quickGroupCollapsed: false,
      isJumping: false,

      // 核心树状态（必须在 data 中完整声明，确保 Vue 2 响应式追踪！）
      nodes: [],
      collapsedIds: [],
      visibleIds: [],
      visibleTotal: 0,

      // 虚拟列表内部状态
      viewportHeight: 520,
      scrollTop: 0,
      virtualWindow: {
        rows: [],
        start: 0,
        end: 0,
        rowHeight: 36,
        topSpace: 0,
        bottomSpace: 0,
      },
    }
  },
  computed: {
    isReportRoute() {
      const path = (this.$route && (this.$route.path || this.$route.name)) || ''
      // 人工检测台账支持按区域汇总查询。
      if (/(^|\/)ManualCheckList\/?$/i.test(path)) return false
      return /report|quota|St21Cn2061/i.test(path)
    },
    isAreaSelectable() {
      if (this.allowSelectArea === false || this.siteOnly || this.busSiteOnly || this.isReportRoute) {
        return false
      }
      return true
    },
    isLight() {
      if (this.light !== null && this.light !== undefined) {
        return Boolean(this.light)
      }
      if (this.$store && this.$store.state && typeof this.$store.state.bgLight === 'boolean') {
        return this.$store.state.bgLight
      }
      try {
        if (localStorage.getItem('bgLight') === 'true') return true
        if (localStorage.getItem('bgLight') === 'false') return false
      } catch (e) {}
      return false
    },
    boxWidth() {
      return this.panelWidth
    },
    isSearching() {
      return Boolean(this.filterText && this.filterText.trim())
    },
    virtualTotalHeight() {
      const rowHeight = this.isSearching ? 52 : 36
      const baseHeight = this.visibleTotal * rowHeight
      // 为底部留出适量滚动缓冲，确保最底部的区域也能精准对齐到视口顶部
      const bottomBuffer = Math.max(0, this.viewportHeight - 2 * rowHeight)
      return baseHeight + bottomBuffer
    },
    quickSites() {
      if (!Array.isArray(this.nodes) || !this.nodes.length) return []
      const combined = [...new Set([...this.favoriteKeys, ...this.recentKeys])]
      return combined
        .map((k) => findNodeByKey(this.nodes, k))
        .filter((node) => node && node.isSite && !node.disabled)
        .slice(0, 10)
    },
    regionIndex() {
      return Array.isArray(this.nodes) ? getSiteRegionIndex(this.nodes) : []
    },
  },
  watch: {
    filterText() {
      this.updateVisibleRows()
      this.scrollToTop()
    },
    showCheckbox(val) {
      if (val) {
        this.syncCheckedKeysFromStorage()
      }
    },
    quickSites() {
      this.$nextTick(() => {
        this.measureViewport()
      })
    },
    initialSiteId(val) {
      if (val) {
        const found = this.nodes && this.nodes.length ? this.selectTargetSite(val) : false
        if (!found && this.st !== '') {
          this.st = ''
          this.loadTree(this.value, '', this.category)
        }
      }
    },
    type(val) {
      if (val && String(val) !== this.value) {
        this.value = String(val)
        this.loadTree(this.value, this.st, this.category)
      }
    },
    $route: {
      immediate: true,
      handler() {
        if (!this.isAreaSelectable) {
          this.$nextTick(() => {
            this.ensureLeafSiteSelected()
          })
        }
      },
    },
    siteOnly(val) {
      if (val) {
        this.$nextTick(() => {
          this.ensureLeafSiteSelected()
        })
      }
    },
    allowSelectArea(val) {
      if (!val) {
        this.$nextTick(() => {
          this.ensureLeafSiteSelected()
        })
      }
    },
  },
  created() {
    // 读取本地持久化面板宽度
    try {
      const savedWidth = Number(localStorage.getItem('siteTreePanelWidth'))
      if (savedWidth >= 280 && savedWidth <= 520) {
        this.panelWidth = savedWidth
        this.width = String(savedWidth)
      }
    } catch (e) {}

    // 读取置顶常用分组折叠状态
    try {
      const savedQuickCollapsed = localStorage.getItem('siteTreeQuickCollapsed')
      if (savedQuickCollapsed !== null) {
        this.quickGroupCollapsed = savedQuickCollapsed === 'true'
      }
    } catch (e) {}

    // 读取本地常用与收藏
    this.loadFavoritesAndRecent()

    // 租户特化
    if (window.localStorage.getItem('projectCode') === 'meitang') {
      this.areaSelectedState = false
    }

    this.getCategoryList()
    this.getTenantStList()

    // 监听全局 StorageEvent 变更同步
    this.setupStorageListener()

    // 监听 EventBus
    this._busStHandler = (val) => {
      const targetSt = val !== null && val !== undefined ? String(val) : ''
      if (targetSt !== this.st) {
        this.st = targetSt
        this._isSelfUpdating = true
        try {
          localStorage.setItem('treeSt', targetSt)
          sessionStorage.setItem('siteType', targetSt)
          this.resetSetLocalItem('treeSt', targetSt)
          this.resetSetItem('siteType', targetSt)
        } finally {
          this._isSelfUpdating = false
        }
        this.loadTree(this.value, this.st, this.category)
      }
    }
    this.$bus.$on('st', this._busStHandler)

    // 监听全局站点树显隐（从巡检单等页面切回监测数据时，自动触发重测高与目标站点类型/站点对齐）
    this._busShowSiteHandler = (name, val) => {
      if (val) {
        this.$nextTick(() => {
          this.measureViewport()
          const sharedSt = localStorage.getItem('treeSt') !== null ? localStorage.getItem('treeSt') : ''
          const sharedSiteId = sessionStorage.getItem('siteId')

          // 保持站点类型与站点选择完全一致
          if (this._needReloadOnShow || sharedSt !== this.st) {
            this._needReloadOnShow = false
            this.st = sharedSt
            this.loadTree(this.value, this.st, this.category)
          } else if (sharedSiteId && sharedSiteId !== this.siteId) {
            this.selectTargetSite(sharedSiteId)
          } else {
            this.revealCurrentSite()
          }
        })
      }
    }
    this.$bus.$on('showSite', this._busShowSiteHandler)

    // 监听全局只选站点模式 (统计报表等业务场景)
    this._busSiteOnlyHandler = (name, val) => {
      const isOnly = typeof name === 'boolean' ? name : Boolean(val)
      this.busSiteOnly = isOnly
      if (isOnly) {
        this.$nextTick(() => {
          this.ensureLeafSiteSelected()
        })
      }
    }
    this.$bus.$on('siteOnly', this._busSiteOnlyHandler)

    // 读取全局统一保存的站点类型（确保监测数据与巡检单等所有界面严格一致）
    if (this.initialSiteId) {
      // 外部明确传入目标站点时，初始优先加载全部类型以确保能够索引定位到目标站点
      this.st = ''
    } else if (localStorage.getItem('treeSt') !== null) {
      this.st = localStorage.getItem('treeSt')
    } else if (sessionStorage.getItem('siteType') !== null) {
      this.st = sessionStorage.getItem('siteType')
    } else {
      this.st = ''
    }
  },
  mounted() {
    this.measureViewport()
    window.addEventListener('resize', this.measureViewport)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measureViewport)
    if (this._storageHandler) {
      window.removeEventListener('setItem', this._storageHandler)
    }
    if (this._busStHandler) {
      this.$bus.$off('st', this._busStHandler)
    }
    if (this._busShowSiteHandler) {
      this.$bus.$off('showSite', this._busShowSiteHandler)
    }
    if (this._busSiteOnlyHandler) {
      this.$bus.$off('siteOnly', this._busSiteOnlyHandler)
    }
    if (this._jumpTimer) {
      clearTimeout(this._jumpTimer)
    }
  },
  methods: {
    measureViewport() {
      this.$nextTick(() => {
        if (this.$refs.viewport) {
          const rect = this.$refs.viewport.getBoundingClientRect()
          if (rect && rect.height > 50) {
            this.viewportHeight = rect.height
            this.updateVirtualWindow()
          }
        }
      })
    },

    /**
     * 计算徽章文字的高对比度颜色（解决浅色底白色字无法看清的问题）
     */
    getBadgeTextColor(color) {
      if (!color) return '#ffffff'
      const c = String(color).trim().toLowerCase()
      if (['yellow', 'cyan', 'lime', 'lightgreen', 'lightblue'].includes(c)) return '#0b1d33'
      if (['red', 'darkred', 'purple', 'black', 'navy', 'blue', 'gray', 'grey'].includes(c)) return '#ffffff'

      let r = 0
      let g = 0
      let b = 0

      if (c.startsWith('rgb')) {
        const match = c.match(/\(([^)]+)\)/)
        if (match) {
          const parts = match[1].split(',').map((n) => parseInt(n.trim(), 10) || 0)
          r = parts[0] || 0
          g = parts[1] || 0
          b = parts[2] || 0
        }
      } else {
        let hex = c.replace('#', '')
        if (/^[0-9a-f]{3}$/.test(hex)) {
          hex = hex.split('').map((char) => char + char).join('')
        }
        if (/^[0-9a-f]{6}/.test(hex)) {
          r = parseInt(hex.substring(0, 2), 16) || 0
          g = parseInt(hex.substring(2, 4), 16) || 0
          b = parseInt(hex.substring(4, 6), 16) || 0
        } else {
          return '#ffffff'
        }
      }

      // 国际通用 YIQ 亮度公式 (0-255)，大于130属于明亮色系，使用深墨色字体保证清晰可读
      const yiq = (r * 299 + g * 587 + b * 114) / 1000
      return yiq >= 130 ? '#0b1d33' : '#ffffff'
    },

    loadFavoritesAndRecent() {
      try {
        const favs = JSON.parse(localStorage.getItem('siteFavorites') || '[]')
        this.favoriteKeys = Array.isArray(favs) ? favs.filter((k) => typeof k === 'string').slice(0, 10) : []
      } catch (e) {
        this.favoriteKeys = []
      }

      try {
        const rec = JSON.parse(localStorage.getItem('recentSiteKeys') || '[]')
        this.recentKeys = Array.isArray(rec) ? rec.filter((k) => typeof k === 'string').slice(0, 6) : []
      } catch (e) {
        this.recentKeys = []
      }
    },

    isFavorite(key) {
      return this.favoriteKeys.includes(String(key))
    },

    toggleFavorite(row) {
      const key = String(row.key)
      let list = [...this.favoriteKeys]
      if (list.includes(key)) {
        list = list.filter((k) => k !== key)
        this.$message_custom('已从常用收藏中移除', 'info', 1.5)
      } else {
        if (list.length >= 10) list.pop()
        list.unshift(key)
        this.$message_custom('已成功添加至常用收藏', 'success', 1.5)
      }
      this.favoriteKeys = list
      localStorage.setItem('siteFavorites', JSON.stringify(list))
    },

    addRecentKey(key) {
      if (!key) return
      const k = String(key)
      const list = [k, ...this.recentKeys.filter((item) => item !== k)].slice(0, 6)
      this.recentKeys = list
      localStorage.setItem('recentSiteKeys', JSON.stringify(list))
    },

    /**
     * 判断当前组件实例在 DOM 树中是否处于隐藏状态（如 GlobalLayout 在巡检单/派工单等页面被 v-show 隐藏）
     */
    isElementHidden() {
      if (!this.$el) return false
      return this.$el.offsetParent === null && this.$el.offsetWidth === 0 && this.$el.offsetHeight === 0
    },

    setupStorageListener() {
      this._storageHandler = (e) => {
        if (!e || this._isSelfUpdating) return
        if (e.key === 'siteId') {
          const newId = sessionStorage.getItem('siteId')
          if (newId && newId !== this.siteId) {
            this.siteId = newId
            this.currentKey = newId
            this.currentSiteName = sessionStorage.getItem('siteName') || ''
            this.currentFullName = sessionStorage.getItem('fullName') || ''
            this.revealCurrentSite()
          }
        } else if (e.key === 'treeSt') {
          // 若当前组件处于隐藏状态（例如 GlobalLayout 在巡检单等页面被隐藏），不触发后台并发查询与竞争
          if (this.isElementHidden()) {
            this._needReloadOnShow = true
            return
          }
          const targetSt = localStorage.getItem('treeSt') !== null ? localStorage.getItem('treeSt') : ''
          if (targetSt !== this.st) {
            this.st = targetSt
            this.loadTree(this.value, this.st, this.category)
          }
        }
      }
      window.addEventListener('setItem', this._storageHandler)
    },

    getCategoryList() {
      ajaxGetDictItems('site_st52_category', null).then((res) => {
        if (res.success && Array.isArray(res.result)) {
          this.categoryList = res.result
        }
      })
    },

    getTenantStList() {
      this.stList = []
      getTenantStByToken().then((res) => {
        if (res.success && Array.isArray(res.result)) {
          this.stList = res.result
          this.stList.unshift({
            value: '',
            title: '请选择监测站点类型',
            text: '请选择监测站点类型',
          })
        } else {
          this.stList.unshift({
            value: '',
            title: '请选择监测站点类型',
            text: '请选择监测站点类型',
          })
        }

        if (this.stList.length <= 2) {
          if (sessionStorage.getItem('treeCategory')) {
            this.category = sessionStorage.getItem('treeCategory')
          } else {
            this.category = '3'
          }
          if (res.result && res.result[1]) {
            this.st = res.result[1].value
            localStorage.setItem('treeSt', this.st)
            sessionStorage.setItem('siteType', this.st)
          }
        } else {
          this.category = ''
          if (localStorage.getItem('treeSt') !== null) {
            this.st = localStorage.getItem('treeSt')
          } else if (sessionStorage.getItem('siteType') !== null) {
            this.st = sessionStorage.getItem('siteType')
          }
        }
        this.loadTree(this.value, this.st, this.category)
      })
    },

    typeChange(val) {
      const targetSt = val !== null && val !== undefined ? String(val) : ''
      this.st = targetSt
      this.siteId = ''
      this.currentKey = ''

      this._isSelfUpdating = true
      try {
        localStorage.setItem('treeSt', targetSt)
        sessionStorage.setItem('siteType', targetSt)
        sessionStorage.setItem('siteId', '')
        sessionStorage.setItem('pipeId', '')
        sessionStorage.setItem('fullName', '')
        sessionStorage.setItem('siteName', '')

        this.resetSetItem('siteId', '')
        this.resetSetItem('pipeId', '')
        this.resetSetItem('fullName', '')
        this.resetSetItem('siteName', '')
        this.resetSetItem('siteType', targetSt)
        this.resetSetLocalItem('treeSt', targetSt)
      } finally {
        this._isSelfUpdating = false
      }

      this.loadTree(this.value, targetSt, this.category)
    },

    onChange(e) {
      this.value = e.target.value
      this.loadTree(this.value, this.st, this.category)
    },

    onCategoryChange(e) {
      this.category = e.target.value
      this.resetSetItem('treeCategory', this.category)
      this.loadTree(this.value, this.st, this.category)
    },

    handleSearchInput() {
      this.updateVisibleRows()
    },

    loadTree(addrType, st, category) {
      this.loading = true
      querySiteTree({
        addrType,
        st,
        category,
      })
        .then((res) => {
          if (res && res.success && res.result) {
            const rawList = Array.isArray(res.result) ? res.result : (res.result.records || [])
            const flatNodes = flattenSiteTree(rawList)
            // 使用 Object.freeze 避免 Vue 递归监听深层大对象，同时赋予响应式更新
            this.nodes = Object.freeze(flatNodes)
            this.syncSiteNamesMap()

            // 默认折叠所有分组
            let collapsed = collapseAllGroups(flatNodes)

            // 尝试展开当前已选中的站点或默认选中第一个可用站点
            let targetNode = null
            if (this.initialSiteId) {
              const targetStr = String(this.initialSiteId)
              targetNode = flatNodes.find(
                (n) => n.isSite && (String(n.key) === targetStr || (n.data && String(n.data.id) === targetStr))
              )
            }
            if (!targetNode) {
              // 业务站点模式下优先读取活跃的 siteId，管网模式(value='3')下才优先 pipeId
              const curId = this.value === '3'
                ? (sessionStorage.getItem('pipeId') || sessionStorage.getItem('siteId'))
                : (sessionStorage.getItem('siteId') || sessionStorage.getItem('pipeId'))
              if (curId) {
                const targetStr = String(curId)
                targetNode = flatNodes.find(
                  (n) =>
                    (this.isAreaSelectable ? true : n.isSite) &&
                    (String(n.key) === targetStr || (n.data && String(n.data.id) === targetStr))
                )
              }
            }
            if (!targetNode || (!this.isAreaSelectable && !targetNode.isSite)) {
              targetNode = flatNodes.find((n) => n.isSite && !n.disabled)
            }

            if (targetNode) {
              collapsed = expandSiteBranch(flatNodes, collapsed, targetNode.id)
              this.siteId = targetNode.key
              this.currentKey = targetNode.key
              this.currentSiteName = targetNode.label
              this.currentSiteType = targetNode.st || this.st || ''
              const breadcrumbs = getNodeBreadcrumbs(flatNodes, targetNode)
              this.currentFullName = breadcrumbs.join(' > ')

              // 若组件在 DOM 中处于隐藏状态（如后台实例），不覆盖全局激活站点的 session/local 数据
              if (!this.isElementHidden()) {
                // 提取所属直接区域/企业
                const parent = targetNode.parentId !== null ? flatNodes[targetNode.parentId] : null
                const areaName = parent ? parent.label : ''
                const areaId = parent ? parent.key : ''

                this._isSelfUpdating = true
                try {
                  this.resetSetItem('siteId', targetNode.key)
                  this.resetSetItem('pipeId', targetNode.key)
                  this.resetSetItem('siteName', targetNode.label)
                  this.resetSetItem('siteType', targetNode.st || this.st || '')
                  this.resetSetItem('siteAreaName', areaName)
                  this.resetSetItem('siteAreaId', areaId)
                  this.resetSetItem('fullName', this.currentFullName)
                  if (this.st !== null && this.st !== undefined) {
                    localStorage.setItem('treeSt', this.st)
                  }
                } finally {
                  this._isSelfUpdating = false
                }

                // 若有父级监听 @change 事件，抛出初始选中事件以驱动页面初次数据加载 (如巡检单/派工单)
                if (this.$listeners && this.$listeners.change) {
                  this.emitChangeEvent(targetNode)
                }
              }
            }

            this.collapsedIds = collapsed
            this.updateVisibleRows()

            if (this.showCheckbox) {
              this.syncCheckedKeysFromStorage()
            }
          } else {
            this.nodes = []
            this.collapsedIds = []
            this.visibleIds = []
            this.visibleTotal = 0
            this.updateVirtualWindow()
          }
        })
        .catch((err) => {
          console.error('loadTree error:', err)
          this.nodes = []
          this.collapsedIds = []
          this.visibleIds = []
          this.visibleTotal = 0
          this.updateVirtualWindow()
        })
        .finally(() => {
          this.loading = false
          this.$nextTick(() => {
            this.measureViewport()
            this.revealCurrentSite()
          })
        })
    },

    updateVisibleRows() {
      const vIds = getSiteTreeIds(this.nodes, this.collapsedIds, this.filterText)
      this.visibleIds = vIds
      this.visibleTotal = vIds.length
      this.updateVirtualWindow()
    },

    updateVirtualWindow() {
      const windowResult = getSiteTreeWindow(
        this.nodes,
        this.visibleIds,
        this.collapsedIds,
        this.filterText,
        this.scrollTop,
        this.viewportHeight
      )
      this.virtualWindow = windowResult
    },

    handleScroll(e) {
      this.scrollTop = Math.max(0, Number(e.target.scrollTop) || 0)
      this.updateVirtualWindow()
      if (!this.isJumping) {
        this.updateActiveRegion()
      }
    },

    /**
     * 根据当前视口滚动位置，动态计算并高亮左侧对应的区域项
     */
    updateActiveRegion() {
      if (this.isSearching || !this.regionIndex.length || !this.visibleIds.length) {
        return
      }

      // 视口位于顶部（20px 以内），高亮侧边栏“顶部”
      if (this.scrollTop <= 20) {
        this.activeRegionId = null
        return
      }

      const rowHeight = this.virtualWindow.rowHeight || 36
      // 取视口顶部偏下 10px 处的行索引，避免浮点数舍入抖动
      const topIndex = Math.min(
        this.visibleIds.length - 1,
        Math.max(0, Math.floor((this.scrollTop + 10) / rowHeight))
      )
      const targetId = this.visibleIds[topIndex]
      const node = this.nodes[targetId]
      if (!node) return

      const regionSet = new Set(this.regionIndex.map((r) => r.id))
      let current = node
      while (current && !regionSet.has(current.id)) {
        current = current.parentId !== null ? this.nodes[current.parentId] : null
      }
      this.activeRegionId = current ? current.id : null
    },

    scrollToTop() {
      this.scrollTop = 0
      if (this.$refs.viewport) {
        this.$refs.viewport.scrollTop = 0
      }
      this.updateVirtualWindow()
    },

    /**
     * 滚动定位到指定行索引
     * @param {Number} index 目标行在 visibleIds 中的索引
     * @param {String} align 对齐方式: 'top' (对齐视口顶部，区域速达专用) | 'center' (居中对齐，站点定位专用)
     */
    scrollToIndex(index, align = 'top') {
      const rowHeight = this.isSearching ? 52 : 36
      let targetScroll = index * rowHeight
      if (align === 'center') {
        targetScroll = Math.max(0, targetScroll - (this.viewportHeight - rowHeight) / 2)
      } else {
        // 'top' 模式：严格对齐到视口顶部
        targetScroll = Math.max(0, targetScroll)
      }
      this.scrollTop = targetScroll
      if (this.$refs.viewport) {
        this.$refs.viewport.scrollTop = targetScroll
      }
      this.updateVirtualWindow()
    },

    toggleCollapse(row) {
      if (!row || row.isSite || !row.hasChildren) return
      const id = row.id
      const set = new Set(this.collapsedIds)
      if (set.has(id)) {
        this.collapsedIds = expandNodeOnly(this.nodes, this.collapsedIds, id)
      } else {
        this.collapsedIds = [...this.collapsedIds, id]
      }
      this.updateVisibleRows()
    },

    handleExpandAll() {
      this.collapsedIds = expandAllGroups()
      this.updateVisibleRows()
    },

    handleCollapseAll() {
      this.collapsedIds = collapseAllGroups(this.nodes)
      this.updateVisibleRows()
      this.scrollToTop()
    },

    handleRowClick(row) {
      if (!row || row.disabled) return
      if (this.showCheckbox) {
        if (this.onlineSelect && row.isSite && !row.online) {
          return
        }
        this.toggleCheck(row)
        return
      }
      if (row.isSite) {
        this.selectSite(row, true)
      } else {
        this.toggleCollapse(row)
        if (this.isAreaSelectable && this.$listeners && this.$listeners.change) {
          this.currentKey = row.key
          this.emitChangeEvent(row)
        }
      }
    },

    selectSite(node, triggerEvent = true) {
      if (!node) return
      this.selectedState = true
      this.siteId = node.key
      this.currentKey = node.key
      this.currentSiteName = node.label
      this.currentSiteType = node.st || this.st || ''

      const breadcrumbs = getNodeBreadcrumbs(this.nodes, node)
      const fullName = breadcrumbs.join(' > ')
      this.currentFullName = fullName

      // 提取所属直接区域/企业
      const parent = node.parentId !== null ? this.nodes[node.parentId] : null
      const areaName = parent ? parent.label : ''
      const areaId = parent ? parent.key : ''

      this._isSelfUpdating = true
      try {
        this.resetSetItem('siteId', node.key)
        this.resetSetItem('pipeId', node.key)
        this.resetSetItem('siteName', node.label)
        this.resetSetItem('siteType', node.st || this.st || '')
        this.resetSetItem('siteAreaName', areaName)
        this.resetSetItem('siteAreaId', areaId)
        this.resetSetItem('fullName', fullName)
      } finally {
        this._isSelfUpdating = false
      }

      this.addRecentKey(node.key)

      if (triggerEvent) {
        this.$emit('selectSite', {
          siteId: node.key,
          siteName: node.label,
          siteType: node.st,
          category: this.category,
        })
        this.emitChangeEvent(node)
      }
    },

    handleSelectAreaScope(row) {
      if (!this.isAreaSelectable || !row || row.disabled) return
      this.siteId = row.key
      this.currentKey = row.key
      this.currentSiteName = row.label
      const breadcrumbs = getNodeBreadcrumbs(this.nodes, row)
      const fullName = breadcrumbs.join(' > ')
      this.currentFullName = fullName

      this._isSelfUpdating = true
      try {
        this.resetSetItem('siteAreaId', row.key)
        this.resetSetItem('siteAreaName', row.label)
        this.resetSetItem('siteId', row.key)
        this.resetSetItem('pipeId', row.key)
        this.resetSetItem('siteName', row.label)
        this.resetSetItem('fullName', fullName)
      } finally {
        this._isSelfUpdating = false
      }

      this.$emit('selectSite', {
        siteId: row.key,
        siteName: row.label,
        siteType: this.st,
        category: this.category,
      })
      this.emitChangeEvent(row)
      this.$message_custom(`已选范围：${row.label}`, 'info', 1.5)
    },

    /**
     * 计算树节点的 scope 业务类型 (兼容 pipeNetwork.vue)
     * 1: 站点/管网叶子, 2: 区域, 3: 流域, 4: 企业/公司, 5: 集团/分组
     */
    getTreeCurrentId(key) {
      if (!key) return null
      const rex = /^[a-zA-Z]/
      if (rex.test(key)) {
        const prefix = String(key).split('_')[0]
        if (prefix === 'A') return 2
        if (prefix === 'R') return 3
        if (prefix === 'C') return 4
        if (prefix === 'G') return 5
        return 2
      }
      return 1
    },

    /**
     * 抛出统一的 @change 事件 (兼容 pipeNetwork.vue 的事件契约)
     */
    emitChangeEvent(node) {
      if (!node) return
      const isSiteLeaf = Boolean(node.isSite)
      const rex = /^[a-zA-Z]/
      const isLetterKey = rex.test(node.key[0])

      const nodeData = Object.assign({}, node.data || {})
      if (!nodeData.id) {
        nodeData.id = node.key && node.key.includes('_') ? node.key.split('_')[1] : node.key
      }
      if (!nodeData.name) {
        nodeData.name = node.label
      }
      if (!nodeData.title) {
        nodeData.title = node.label
      }

      // type: 1=站点, 2=管网, 4=区域
      let emitType = 1
      if (!isSiteLeaf || isLetterKey) {
        emitType = 4
      } else if (this.value === '3') {
        emitType = 2
      } else {
        emitType = 1
      }

      const scope = this.getTreeCurrentId(node.key)
      this.$emit('change', {
        type: emitType,
        data: nodeData,
        scope: scope,
      })
    },

    /**
     * 外部指定站点选中定位 (兼容 initialSiteId)
     */
    selectTargetSite(targetId) {
      if (!targetId || !this.nodes || !this.nodes.length) return false
      const targetStr = String(targetId)
      let target = this.nodes.find(
        (n) => n.isSite && (String(n.key) === targetStr || (n.data && String(n.data.id) === targetStr))
      )
      if (!target) {
        target = this.nodes.find(
          (n) => String(n.key) === targetStr || (n.data && String(n.data.id) === targetStr)
        )
      }
      if (target) {
        if (!this.isAreaSelectable && !target.isSite) {
          const firstSite = this.nodes.find((n) => n.isSite && !n.disabled)
          if (firstSite) {
            target = firstSite
          } else {
            return false
          }
        }
        this.collapsedIds = expandSiteBranch(this.nodes, this.collapsedIds, target.id)
        this.updateVisibleRows()
        if (target.isSite) {
          this.selectSite(target, true)
        } else {
          this.handleSelectAreaScope(target)
        }
        this.$nextTick(() => {
          this.revealCurrentSite()
        })
        return true
      }
      return false
    },

    /**
     * 当进入报表或仅站点模式时，确保当前选中的是叶子站点，非叶子节点自动回退到第一个可用叶子站点
     */
    ensureLeafSiteSelected() {
      if (this.isAreaSelectable) return
      if (!this.nodes || !this.nodes.length) return

      const curId = this.siteId || sessionStorage.getItem('siteId')
      let currentNode = null
      if (curId) {
        const curStr = String(curId)
        currentNode = this.nodes.find(
          (n) => String(n.key) === curStr || (n.data && String(n.data.id) === curStr)
        )
      }

      if (!currentNode || !currentNode.isSite) {
        const firstSite = this.nodes.find((n) => n.isSite && !n.disabled)
        if (firstSite) {
          this.collapsedIds = expandSiteBranch(this.nodes, this.collapsedIds, firstSite.id)
          this.updateVisibleRows()
          this.selectSite(firstSite, true)
          this.$nextTick(() => {
            this.revealCurrentSite()
          })
        }
      }
    },

    handleSelectQuickSite(item) {
      if (!item) return
      this.collapsedIds = expandSiteBranch(this.nodes, this.collapsedIds, item.id)
      this.updateVisibleRows()
      this.selectSite(item, true)
      this.$nextTick(() => {
        this.revealCurrentSite()
      })
    },

    toggleQuickGroup() {
      this.quickGroupCollapsed = !this.quickGroupCollapsed
      try {
        localStorage.setItem('siteTreeQuickCollapsed', String(this.quickGroupCollapsed))
      } catch (e) {}
      this.$nextTick(() => {
        this.measureViewport()
      })
    },

    handleJumpRegion(reg) {
      if (this.filterText) {
        this.filterText = ''
      }
      if (!reg) {
        this.activeRegionId = null
        this.scrollToTop()
        return
      }

      this.isJumping = true
      this.activeRegionId = reg.id
      clearTimeout(this._jumpTimer)
      this._jumpTimer = setTimeout(() => {
        this.isJumping = false
      }, 400)

      this.collapsedIds = expandNodeOnly(this.nodes, this.collapsedIds, reg.id)
      this.updateVisibleRows()

      this.$nextTick(() => {
        const index = this.visibleIds.indexOf(reg.id)
        if (index !== -1) {
          this.scrollToIndex(index, 'top')
        }
      })
    },

    revealCurrentSite() {
      if (!this.siteId || !Array.isArray(this.nodes)) return
      const node = findNodeByKey(this.nodes, this.siteId)
      if (!node) return
      this.collapsedIds = expandSiteBranch(this.nodes, this.collapsedIds, node.id)
      this.updateVisibleRows()
      this.$nextTick(() => {
        const index = this.visibleIds.indexOf(node.id)
        if (index !== -1) {
          this.scrollToIndex(index, 'center')
        }
      })
    },

    getDescendantSiteKeys(node) {
      if (!node || !Array.isArray(this.nodes)) return []
      const result = []
      const stack = [node.id]
      while (stack.length) {
        const currId = stack.pop()
        const curr = this.nodes[currId]
        if (!curr) continue
        if (curr.isSite && !curr.disabled && (!this.onlineSelect || curr.online)) {
          result.push(String(curr.key))
        }
        if (Array.isArray(curr.childrenIds)) {
          for (let i = 0; i < curr.childrenIds.length; i++) {
            stack.push(curr.childrenIds[i])
          }
        }
      }
      return result
    },

    isChecked(target) {
      if (!target) return false
      if (typeof target === 'object') {
        if (target.isSite) {
          return this.checkedKeys.includes(String(target.key))
        }
        const childKeys = this.getDescendantSiteKeys(target)
        return childKeys.length > 0 && childKeys.every((k) => this.checkedKeys.includes(k))
      }
      return this.checkedKeys.includes(String(target))
    },

    isIndeterminate(target) {
      if (!target || target.isSite) return false
      const childKeys = this.getDescendantSiteKeys(target)
      if (!childKeys.length) return false
      const checkedCount = childKeys.filter((k) => this.checkedKeys.includes(k)).length
      return checkedCount > 0 && checkedCount < childKeys.length
    },

    toggleCheck(row) {
      if (!row) return
      const set = new Set(this.checkedKeys)
      if (row.isSite) {
        const k = String(row.key)
        if (set.has(k)) {
          set.delete(k)
        } else {
          set.add(k)
        }
      } else {
        const childKeys = this.getDescendantSiteKeys(row)
        const allChecked = childKeys.length > 0 && childKeys.every((k) => set.has(k))
        if (allChecked) {
          childKeys.forEach((k) => set.delete(k))
        } else {
          childKeys.forEach((k) => set.add(k))
        }
      }
      this.checkedKeys = Array.from(set)
      this.resetSetItem('sites', this.checkedKeys.join(','))
      this.syncSiteNamesMap()
    },

    handleSelectAllCurrent() {
      const currentSiteKeys = this.visibleIds
        .map((id) => this.nodes[id])
        .filter((n) => n && n.isSite && !n.disabled && (!this.onlineSelect || n.online))
        .map((n) => n.key)

      const set = new Set([...this.checkedKeys, ...currentSiteKeys])
      this.checkedKeys = Array.from(set)
      this.resetSetItem('sites', this.checkedKeys.join(','))
      this.syncSiteNamesMap()
      this.$message_custom(`已勾选 ${currentSiteKeys.length} 个站点`, 'success', 1.5)
    },

    handleClearChecked() {
      this.checkedKeys = []
      this.resetSetItem('sites', '')
    },

    syncCheckedKeysFromStorage() {
      const raw = sessionStorage.getItem('sites') || ''
      this.checkedKeys = raw ? raw.split(',').filter(Boolean) : []
    },

    /**
     * 将当前站点树中的站点ID与名称映射持久化至 sessionStorage 并通过 EventBus 广播
     */
    syncSiteNamesMap() {
      if (!this.nodes || !this.nodes.length) return
      const map = {}
      this.nodes.forEach((n) => {
        if (n.isSite && n.key) {
          map[String(n.key)] = n.label
        }
      })
      try {
        let existing = {}
        const raw = sessionStorage.getItem('siteNamesMap')
        if (raw) existing = JSON.parse(raw) || {}
        const merged = Object.assign(existing, map)
        sessionStorage.setItem('siteNamesMap', JSON.stringify(merged))
        this.$bus.$emit('siteNamesMap', merged)
      } catch (e) {}
    },

    /**
     * 计算行左内边距（方案一：站点零阶梯缩进，通栏分组微缩进）
     */
    getRowPaddingLeft(row) {
      if (this.isSearching) {
        return '10px'
      }
      if (row.isSite) {
        // 站点节点统一靠左 12px，取消阶梯递增空白，左侧由细导轨线连接
        return '12px'
      }
      // 分组节点（通栏条）微阶梯缩进：根分组 6px，次级分组每级微增 8px
      return `${Math.min(row.level, 3) * 8 + 6}px`
    },

    getIconClass(row) {
      switch (String(row.st)) {
        case '31':
          return 'icon-feiqi'
        case '32':
          return 'icon-yiliaofeishui'
        case '35':
          return 'icon-turang'
        case '21':
          return 'icon-shuizhijiancezhan'
        case '22':
          return 'icon-kongqijiance'
        case '60':
        case '61':
          return 'icon-shuikushuiwenzhan'
        case '52':
          return 'icon-yiliaofeishui'
        default:
          return 'icon-feiqi'
      }
    },

    getRowTooltip(row) {
      if (!row.isSite) {
        return `${row.label} (在线: ${row.onlineNum}/${row.total})`
      }
      const statusText = row.online ? '【在线】' : '【离线】'
      const std = row.currentStandard ? ` 标准: ${row.currentStandard.title}` : ''
      const up = row.upStandard === 'true' ? ' 达标' : row.upStandard === 'false' ? ' 超标' : ''
      const time = row.lastTime ? `\n最后时间: ${row.lastTime}` : ''
      const path = row.path ? `\n归属路径: ${row.path}` : ''
      return `${row.label} ${statusText}${std}${up}${path}${time}`
    },

    startResize(e) {
      e.preventDefault()
      const startX = e.clientX
      const startWidth = this.panelWidth

      const onMouseMove = (moveEvt) => {
        const delta = moveEvt.clientX - startX
        const target = Math.max(280, Math.min(520, startWidth + delta))
        this.panelWidth = target
        this.width = String(target)
      }

      const onMouseUp = () => {
        window.removeEventListener('mousemove', onMouseMove)
        window.removeEventListener('mouseup', onMouseUp)
        try {
          localStorage.setItem('siteTreePanelWidth', String(this.panelWidth))
        } catch (err) {}
        this.$nextTick(() => {
          this.measureViewport()
        })
      }

      window.addEventListener('mousemove', onMouseMove)
      window.addEventListener('mouseup', onMouseUp)
    },

    close() {
      this.visiable = false
      this.width = '25'
    },

    show() {
      this.visiable = true
      this.width = String(this.panelWidth)
      this.$nextTick(() => {
        this.measureViewport()
      })
    },

    filterOption(input, option) {
      const text =
        option.componentOptions && option.componentOptions.children && option.componentOptions.children[0]
          ? option.componentOptions.children[0].text
          : ''
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>

<style lang="scss" scoped>
.treeMain {
  height: calc(88vh - 5px);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  flex-shrink: 0;

  .site-panel-wrapper {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;

    .project-box {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 6px;
      box-sizing: border-box;

      .content {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        .box {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          background: rgba(10, 30, 65, 0.45);
          border-radius: 4px;
          overflow: hidden;

        /* 顶部控制面板 */
        .tree-header {
          flex-shrink: 0;
          padding: 8px 10px 6px 10px;
          border-bottom: 1px solid rgba(24, 144, 255, 0.2);

          .header-dimension-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 6px;

            ::v-deep .ant-radio-button-wrapper {
              background: transparent;
              color: #64b5f6;
              border-color: rgba(24, 144, 255, 0.4);
              height: 26px;
              line-height: 24px;
              padding: 0 10px;
              font-size: 12px;
            }
            ::v-deep .ant-radio-button-wrapper-checked {
              color: #fff !important;
              background: #1890ff;
              border-color: #1890ff !important;
            }

            .tree-action-links {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #64b5f6;

              .action-link {
                cursor: pointer;
                padding: 0 2px;
                transition: color 0.2s;
                user-select: none;
                white-space: nowrap;

                &:hover {
                  color: #fff;
                  text-decoration: underline;
                }
              }

              .action-divider {
                color: rgba(100, 181, 246, 0.4);
                font-size: 11px;
                margin: 0 3px;
              }
            }
          }

          .header-type-row {
            margin-bottom: 6px;
            ::v-deep .ant-select-selection {
              background-color: rgba(16, 42, 85, 0.6);
              color: #dbe6f3;
              font-size: 12px;
              border-color: rgba(24, 144, 255, 0.4);
              height: 28px;
            }
            ::v-deep .ant-select-selection__rendered {
              line-height: 28px;
            }
            ::v-deep .ant-select-arrow {
              color: #64b5f6;
            }
          }

          .header-search-row {
            margin-bottom: 6px;
            ::v-deep .ant-input {
              background-color: rgba(16, 42, 85, 0.6);
              border-color: rgba(24, 144, 255, 0.4);
              color: #fff;
              font-size: 12px;
              height: 28px;
              &::placeholder {
                color: #90a4ae;
              }
              &:focus {
                border-color: #1890ff;
                box-shadow: 0 0 4px rgba(24, 144, 255, 0.5);
              }
            }
          }

          /* 多选工具栏 */
          .header-checkbox-toolbar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 4px;
            border-top: 1px dashed rgba(24, 144, 255, 0.2);

            .selected-count {
              color: #80d8ff;
              font-size: 11px;
            }
            .checkbox-btns ::v-deep .ant-btn {
              padding: 0 4px;
              font-size: 11px;
            }
          }
        }

        /* 中间主体区域：左侧区域导引轨 + 右侧虚拟视口 (布局对齐现代极简风) */
        .tree-body-wrapper {
          flex: 1;
          min-height: 0;
          display: flex;
          overflow: hidden;
          position: relative;

          /* 左侧区域导引轨 (简洁专业，无“速达”大标题，细窄侧栏) */
          .tree-regions-sidebar {
            flex-shrink: 0;
            width: 66px;
            height: 100%;
            border-right: 1px solid rgba(24, 144, 255, 0.22);
            background: rgba(7, 20, 44, 0.65);
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .regions-sidebar-list {
              flex: 1;
              overflow-y: auto;
              overflow-x: hidden;
              scrollbar-width: none;
              &::-webkit-scrollbar {
                display: none;
              }
              padding: 4px 0;

              .region-sidebar-item {
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                min-height: 36px;
                padding: 4px 3px;
                margin-bottom: 2px;
                color: #8fa9c4;
                font-size: 11px;
                line-height: 14px;
                text-align: center;
                word-break: break-all;
                cursor: pointer;
                transition: all 0.18s;
                border-left: 3px solid transparent;
                user-select: none;

                &:hover {
                  color: #e1f5fe;
                  background: rgba(24, 144, 255, 0.15);
                }

                &.active {
                  color: #40c4ff;
                  background: rgba(24, 144, 255, 0.25);
                  border-left-color: #00e5ff;
                  font-weight: 600;
                }
              }
            }
          }

          /* 右侧主体内容容器：置顶常用分组 + 虚拟滚动视口 */
          .tree-main-content {
            flex: 1;
            min-width: 0;
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            /* 树顶常驻常用与收藏独立分组 */
            .pinned-quick-group {
              flex-shrink: 0;
              margin: 4px 6px 2px 6px;
              background: rgba(13, 35, 71, 0.7);
              border: 1px solid rgba(24, 144, 255, 0.35);
              border-radius: 6px;
              overflow: hidden;
              transition: all 0.2s ease;

              .quick-group-header {
                height: 28px;
                line-height: 28px;
                padding: 0 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: linear-gradient(90deg, rgba(250, 173, 20, 0.18) 0%, rgba(24, 144, 255, 0.12) 100%);
                border-bottom: 1px solid rgba(24, 144, 255, 0.2);
                cursor: pointer;
                user-select: none;
                transition: background 0.2s;

                &:hover {
                  background: linear-gradient(90deg, rgba(250, 173, 20, 0.28) 0%, rgba(24, 144, 255, 0.22) 100%);
                }

                .header-left {
                  display: flex;
                  align-items: center;
                  gap: 5px;
                  font-size: 12px;

                  .expander-icon {
                    color: #90a4ae;
                    font-size: 11px;
                    display: inline-flex;
                    align-items: center;
                  }

                  .star-icon {
                    color: #faad14;
                    font-size: 13px;
                  }

                  .group-title {
                    color: #ffca28;
                    font-weight: 500;
                  }

                  .group-count {
                    color: #90caf9;
                    font-size: 11px;
                  }
                }

                .header-right {
                  .collapse-hint {
                    font-size: 11px;
                    color: #64b5f6;
                    cursor: pointer;
                    &:hover {
                      color: #ffffff;
                    }
                  }
                }
              }

              &.is-collapsed {
                .quick-group-header {
                  border-bottom: none;
                }
              }

              .quick-site-list {
                max-height: 180px;
                overflow-y: auto;
                scrollbar-width: thin;
                scrollbar-color: rgba(24, 144, 255, 0.35) transparent;

                &::-webkit-scrollbar {
                  width: 3px;
                }
                &::-webkit-scrollbar-thumb {
                  background: rgba(24, 144, 255, 0.35);
                  border-radius: 3px;
                }

                .quick-site-item {
                  display: flex;
                  align-items: center;
                  height: 28px;
                  padding: 0 8px 0 10px;
                  cursor: pointer;
                  transition: all 0.15s ease;
                  border-bottom: 1px solid rgba(24, 144, 255, 0.08);

                  &:last-child {
                    border-bottom: none;
                  }

                  &:hover {
                    background: rgba(24, 144, 255, 0.18);
                    .item-name {
                      color: #ffffff;
                    }
                  }

                  &.is-active {
                    background: rgba(24, 144, 255, 0.35);
                    border-left: 3px solid #00e5ff;
                    .item-name {
                      color: #00e5ff;
                      font-weight: 500;
                    }
                  }

                  .item-status-icon {
                    flex-shrink: 0;
                    margin-right: 6px;
                    display: inline-flex;
                    align-items: center;

                    .site-online-dot {
                      display: inline-block;
                      width: 6px;
                      height: 6px;
                      border-radius: 50%;
                      background: #90a4ae;

                      &.online {
                        background: #52c41a;
                        box-shadow: 0 0 5px #52c41a;
                      }
                    }
                  }

                  .item-name {
                    flex: 1;
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                    color: #dbe6f3;
                  }

                  .item-badges {
                    flex-shrink: 0;
                    margin-left: 6px;
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    .status-tag {
                      font-size: 10px;
                      padding: 0 4px;
                      border-radius: 2px;
                      line-height: 16px;
                      height: 16px;
                      font-weight: 500;

                      &.standard {
                        border: 1px solid rgba(255, 255, 255, 0.3);
                      }
                      &.up-standard {
                        background: rgba(82, 196, 26, 0.2);
                        color: #52c41a;
                        border: 1px solid rgba(82, 196, 26, 0.4);
                      }
                      &.over-standard {
                        background: rgba(245, 34, 45, 0.2);
                        color: #ff4d4f;
                        border: 1px solid rgba(245, 34, 45, 0.4);
                      }
                    }
                  }

                  .item-actions {
                    flex-shrink: 0;
                    margin-left: 6px;
                    display: flex;
                    align-items: center;

                    .action-star {
                      font-size: 12px;
                      color: #90a4ae;
                      cursor: pointer;
                      transition: color 0.2s;

                      &:hover {
                        color: #ffd54f;
                      }
                      &.active {
                        color: #faad14;
                      }
                    }
                  }
                }
              }
            }

            /* 右侧虚拟滚动视口 */
            .tree-virtual-viewport {
            flex: 1;
            min-width: 0;
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            position: relative;
            padding: 2px 0;

            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-track {
              background: rgba(0, 0, 0, 0.1);
            }
            &::-webkit-scrollbar-thumb {
              background: rgba(24, 144, 255, 0.4);
              border-radius: 2px;
            }

            .tree-status-message {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 40px 16px;
              color: #90a4ae;
              font-size: 13px;
            }

            .virtual-space {
              position: relative;
              width: 100%;

              .virtual-window {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                width: 100%;

                .virtual-row {
                  display: flex;
                  align-items: center;
                  box-sizing: border-box;
                  padding-right: 8px;
                  cursor: pointer;
                  transition: background-color 0.15s;
                  position: relative;

                  &:hover {
                    .row-hover-actions {
                      opacity: 1;
                      visibility: visible;
                    }
                  }

                  /* 方案一：分组通栏条设计 (Section Header) */
                  &.is-group {
                    background: rgba(13, 34, 69, 0.65);
                    border-top: 1px solid rgba(24, 144, 255, 0.12);
                    border-bottom: 1px solid rgba(24, 144, 255, 0.12);
                    user-select: none;

                    &.is-root-group {
                      background: rgba(16, 44, 90, 0.85);
                      border-top-color: rgba(24, 144, 255, 0.25);
                      border-bottom-color: rgba(24, 144, 255, 0.2);
                      .row-title {
                        color: #ffffff;
                        font-weight: 600;
                      }
                    }

                    &:hover {
                      background: rgba(24, 144, 255, 0.28) !important;
                    }

                    .row-title {
                      color: #e2edfa;
                      font-size: 13px;
                      font-weight: 500;
                    }

                    .group-count {
                      font-size: 11px;
                      color: #64b5f6;
                      margin-left: 6px;
                      font-weight: normal;
                    }
                  }

                  /* 方案一：站点行零阶梯缩进，靠左平铺，左侧带 2px 细从属导轨线 */
                  &.is-site {
                    position: relative;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.03);

                    &::before {
                      content: '';
                      position: absolute;
                      left: 5px;
                      top: 0;
                      bottom: 0;
                      width: 2px;
                      background: rgba(24, 144, 255, 0.22);
                      border-radius: 1px;
                      transition: all 0.18s;
                    }

                    &:hover {
                      background-color: rgba(24, 144, 255, 0.18) !important;
                      &::before {
                        background: #40a9ff;
                        box-shadow: 0 0 4px rgba(64, 169, 255, 0.5);
                      }
                    }

                    &.is-active {
                      background-color: rgba(24, 144, 255, 0.32) !important;
                      &::before {
                        background: #00e5ff;
                        box-shadow: 0 0 6px #00e5ff;
                        width: 3px;
                      }
                      .row-title {
                        color: #ffffff !important;
                        font-weight: 600;
                      }
                    }

                    &.is-searching::before {
                      display: none;
                    }
                  }

                  /* 搜索状态激活样式 */
                  &.is-searching.is-active {
                    background-color: rgba(24, 144, 255, 0.35) !important;
                    border-left: 3px solid #00e5ff;
                    .row-title {
                      color: #ffffff !important;
                      font-weight: 600;
                    }
                  }

                  &.is-disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                  }

                  /* 展开箭头 */
                  .row-expander {
                    flex-shrink: 0;
                    width: 16px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                  }

                  /* 复选框 */
                  .row-checkbox {
                    flex-shrink: 0;
                    margin-right: 5px;
                  }

                  /* 图标区 */
                  .row-icon-box {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    margin-right: 6px;

                    .site-online-dot {
                      display: inline-block;
                      width: 7px;
                      height: 7px;
                      border-radius: 50%;
                      &.online {
                        background: #00e676;
                        box-shadow: 0 0 5px #00e676;
                      }
                      &.offline {
                        background: #90a4ae;
                      }
                    }

                    .iconfont {
                      font-size: 14px;
                    }
                  }

                  /* 文本与路径 */
                  .row-content-box {
                    flex: 1;
                    min-width: 0;
                    overflow: hidden;

                    .row-title {
                      display: flex;
                      align-items: center;
                      width: 100%;
                      min-width: 0;
                      color: #b0bec5;
                      font-size: 13px;
                      line-height: 18px;

                      .row-name {
                        flex: 0 1 auto;
                        min-width: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }

                      .group-count {
                        flex-shrink: 0;
                        font-size: 11px;
                        color: #78909c;
                        margin-left: 5px;
                        white-space: nowrap;
                        user-select: none;
                      }

                      .search-hit {
                        color: #ffeb3b;
                        font-weight: bold;
                      }
                    }

                    .row-subpath {
                      font-size: 10px;
                      color: #78909c;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      line-height: 14px;
                      margin-top: 2px;
                    }
                  }

                  /* 右侧徽章 (始终靠右对齐，高对比度清晰文本) */
                  .row-badges {
                    flex-shrink: 0;
                    margin-left: auto;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    padding-left: 6px;

                    .status-tag {
                      display: inline-block;
                      padding: 1px 6px;
                      border-radius: 3px;
                      font-size: 11px;
                      line-height: 15px;
                      text-align: center;
                      font-weight: 600;
                      white-space: nowrap;

                      &.up-standard {
                        background: #00e676;
                        color: #052e16;
                      }

                      &.over-standard {
                        background: #ff1744;
                        color: #ffffff;
                        text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
                      }

                      &.standard {
                        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
                      }
                    }
                  }

                  /* 悬浮微操作 */
                  .row-hover-actions {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    margin-left: 4px;
                    opacity: 0;
                    visibility: hidden;
                    transition: all 0.15s;

                    .action-icon {
                      font-size: 14px;
                      color: #90a4ae;
                      cursor: pointer;
                      &:hover {
                        color: #ffd54f;
                      }
                      &.active {
                        color: #faad14;
                      }
                    }

                    /* 选为范围按钮：深色科技风半透明微胶囊，完美融入通栏深蓝底色 */
                    .group-select-btn {
                      display: inline-flex;
                      align-items: center;
                      gap: 3px;
                      height: 20px;
                      line-height: 18px;
                      padding: 0 7px;
                      font-size: 11px;
                      color: #40c4ff;
                      background: rgba(24, 144, 255, 0.15);
                      border: 1px solid rgba(24, 144, 255, 0.4);
                      border-radius: 3px;
                      cursor: pointer;
                      white-space: nowrap;
                      user-select: none;
                      transition: all 0.18s ease;

                      .btn-icon {
                        font-size: 11px;
                        color: #40c4ff;
                        transition: color 0.18s;
                      }

                      &:hover {
                        color: #ffffff;
                        background: rgba(24, 144, 255, 0.45);
                        border-color: #00e5ff;
                        box-shadow: 0 0 6px rgba(0, 229, 255, 0.45);

                        .btn-icon {
                          color: #00e5ff;
                        }
                      }

                      &.is-selected {
                        color: #00e5ff;
                        background: rgba(0, 229, 255, 0.25);
                        border-color: #00e5ff;
                        font-weight: 500;
                      }

                      &:active {
                        background: #1890ff;
                        color: #ffffff;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        }

        /* 底部状态摘要栏 */
        .tree-footer-bar {
          flex-shrink: 0;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
          border-top: 1px solid rgba(24, 144, 255, 0.2);
          background: rgba(13, 37, 77, 0.85);

          .footer-selection-info {
            flex: 1;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;

            .footer-label {
              color: #78909c;
            }
            .footer-value {
              color: #40c4ff;
              font-weight: 500;
            }
          }

          .footer-locate-btn {
            flex-shrink: 0;
            color: #40c4ff;
            padding: 0 4px;
            font-size: 12px;
          }
        }
      }
    }

    }

    /* 宽度调整拖拽线 */
    .resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: 0;
      width: 5px;
      cursor: col-resize;
      background: transparent;
      z-index: 90;
      transition: background 0.2s;

      &:hover {
        background: rgba(24, 144, 255, 0.6);
      }
    }
  }

  /* 侧栏收起状态下的展开按钮 */
  .show-trigger {
    width: 13px;
    height: 48px;
    line-height: 48px;
    background: #14356c;
    border: 1px solid #2c58a6;
    border-left: none;
    color: #64b5f6;
    cursor: pointer;
    text-align: center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    font-size: 11px;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.4);
    transition: all 0.2s ease;

      &:hover {
        background: #1890ff;
        border-color: #40a9ff;
        color: #ffffff;
        box-shadow: 0 0 10px rgba(24, 144, 255, 0.8);
      }
    }

  /* ================= 浅色模式专属适配 (Light Theme Optimization) ================= */
  &.is-light,
  .lightColor & {
    .site-panel-wrapper {
      /* 外层科技边框转为现代浅色卡片边框 */
      ::v-deep .site-tree.border-content,
      ::v-deep .border-content {
        border: 1px solid #d9d9d9 !important;
        border-radius: 6px !important;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06) !important;
        background: #ffffff !important;

        /* 隐藏深色科技风角标 */
        .t_line_box {
          display: none !important;
        }
      }

      .project-box {
        padding: 4px;

        .content .box {
          background: #ffffff !important;
          border-radius: 4px;

          /* 顶部控制面板 */
          .tree-header {
            background: #ffffff !important;
            border-bottom: 1px solid #f0f0f0 !important;

            .header-dimension-row {
              ::v-deep .ant-radio-button-wrapper {
                background: #fafafa !important;
                color: #595959 !important;
                border-color: #d9d9d9 !important;

                &:hover {
                  color: #1890ff !important;
                }
              }
              ::v-deep .ant-radio-button-wrapper-checked {
                background: #1890ff !important;
                color: #ffffff !important;
                border-color: #1890ff !important;
                box-shadow: -1px 0 0 0 #1890ff !important;
              }

              .tree-action-links {
                color: #8c8c8c !important;

                .action-link {
                  color: #1890ff !important;
                  &:hover {
                    color: #40a9ff !important;
                  }
                  &.close-link {
                    color: #8c8c8c !important;
                    &:hover {
                      color: #ff4d4f !important;
                    }
                  }
                }

                .action-divider {
                  color: #e8e8e8 !important;
                }
              }
            }

            .header-type-row {
              ::v-deep .ant-select-selection {
                background-color: #ffffff !important;
                color: rgba(0, 0, 0, 0.85) !important;
                border-color: #d9d9d9 !important;
                box-shadow: none !important;

                &:hover {
                  border-color: #40a9ff !important;
                }
              }
              ::v-deep .ant-select-selection__rendered {
                color: rgba(0, 0, 0, 0.85) !important;
              }
              ::v-deep .ant-select-arrow {
                color: rgba(0, 0, 0, 0.45) !important;
              }
            }

            .header-search-row {
              ::v-deep .ant-input {
                background-color: #ffffff !important;
                border-color: #d9d9d9 !important;
                color: rgba(0, 0, 0, 0.85) !important;

                &::placeholder {
                  color: #bfbfbf !important;
                }
                &:hover {
                  border-color: #40a9ff !important;
                }
                &:focus {
                  border-color: #1890ff !important;
                  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
                }
              }
              .ant-input-prefix i {
                color: #8c8c8c !important;
              }
            }

            .header-checkbox-toolbar {
              border-top: 1px dashed #f0f0f0 !important;
              .selected-count {
                color: #1890ff !important;
                font-weight: 500;
              }
            }
          }

          /* 主体内容区 */
          .tree-body-wrapper {
            /* 左侧导引栏 */
            .tree-regions-sidebar {
              background: #f7f9fc !important;
              border-right: 1px solid #f0f0f0 !important;

              .regions-sidebar-list {
                .region-sidebar-item {
                  color: #595959 !important;

                  &:hover {
                    color: #1890ff !important;
                    background: #f0f5ff !important;
                  }

                  &.active {
                    color: #1890ff !important;
                    background: #e6f7ff !important;
                    border-left-color: #1890ff !important;
                    font-weight: 600 !important;
                  }
                }
              }
            }

            /* 右侧内容区 */
            .tree-main-content {
              /* 常用与收藏分组 */
              .pinned-quick-group {
                background: #ffffff !important;
                border: 1px solid #ffe58f !important;
                box-shadow: 0 1px 4px rgba(250, 173, 20, 0.12) !important;

                .quick-group-header {
                  background: #fffbe6 !important;
                  border-bottom: 1px solid #ffe58f !important;

                  &:hover {
                    background: #fff1b8 !important;
                  }

                  .header-left {
                    .star-icon {
                      color: #faad14 !important;
                    }
                    .group-title {
                      color: #d46b08 !important;
                      font-weight: 600;
                    }
                    .group-count {
                      color: #8c8c8c !important;
                    }
                    .expander-icon {
                      color: #8c8c8c !important;
                    }
                  }

                  .header-right .collapse-hint {
                    color: #1890ff !important;
                  }
                }

                .quick-site-list {
                  scrollbar-color: #d9d9d9 transparent !important;
                  &::-webkit-scrollbar-thumb {
                    background: #d9d9d9 !important;
                  }

                  .quick-site-item {
                    border-bottom: 1px solid #f5f5f5 !important;

                    &:hover {
                      background: #f5f5f5 !important;
                      .item-name {
                        color: #1890ff !important;
                      }
                    }

                    &.is-active {
                      background: #e6f7ff !important;
                      border-left: 3px solid #1890ff !important;
                      .item-name {
                        color: #1890ff !important;
                        font-weight: 600;
                      }
                    }

                    .item-name {
                      color: #262626 !important;
                    }
                  }
                }
              }

              /* 虚拟列表 */
              .tree-virtual-viewport {
                background: #ffffff !important;

                &::-webkit-scrollbar-track {
                  background: #fafafa !important;
                }
                &::-webkit-scrollbar-thumb {
                  background: #d9d9d9 !important;
                  &:hover {
                    background: #bfbfbf !important;
                  }
                }

                .tree-status-message {
                  color: #8c8c8c !important;
                }

                .virtual-space .virtual-window .virtual-row {
                  /* 通栏分组行 */
                  &.is-group {
                    background: #fafafa !important;
                    border-top: 1px solid #f0f0f0 !important;
                    border-bottom: 1px solid #f0f0f0 !important;

                    &.is-root-group {
                      background: #f0f5ff !important;
                      border-top-color: #d6e4ff !important;
                      border-bottom-color: #d6e4ff !important;
                      .row-title {
                        color: #1d39c4 !important;
                        font-weight: 600 !important;
                      }
                    }

                    &:hover {
                      background: #e6f7ff !important;
                    }

                    .row-title {
                      color: #262626 !important;
                      font-weight: 500;
                    }

                    .group-count {
                      color: #8c8c8c !important;
                    }

                    .row-expander {
                      color: #8c8c8c !important;
                    }
                  }

                  /* 站点行 */
                  &.is-site {
                    border-bottom: 1px solid #f9f9f9 !important;

                    &::before {
                      background: #e8e8e8 !important;
                    }

                    &:hover {
                      background-color: #f5f5f5 !important;
                      &::before {
                        background: #1890ff !important;
                        box-shadow: none !important;
                      }
                      .row-content-box .row-title {
                        color: #1890ff !important;
                      }
                    }

                    &.is-active {
                      background-color: #e6f7ff !important;
                      &::before {
                        background: #1890ff !important;
                        box-shadow: none !important;
                        width: 3px !important;
                      }
                      .row-content-box .row-title {
                        color: #1890ff !important;
                        font-weight: 600 !important;
                      }
                    }

                    .row-content-box {
                      .row-title {
                        color: #262626 !important;

                        .row-name {
                          color: inherit;
                        }
                        .group-count {
                          color: #8c8c8c !important;
                        }
                        .search-hit {
                          color: #f5222d !important;
                          background: #fff1f0;
                        }
                      }

                      .row-subpath {
                        color: #8c8c8c !important;
                      }
                    }

                    .row-icon-box {
                      .site-online-dot.offline {
                        background: #d9d9d9 !important;
                      }
                      .iconfont {
                        color: #8c8c8c;
                      }
                    }
                  }

                  &.is-searching.is-active {
                    background-color: #e6f7ff !important;
                    border-left: 3px solid #1890ff !important;
                    .row-content-box .row-title {
                      color: #1890ff !important;
                      font-weight: 600 !important;
                    }
                  }

                  /* 悬浮微操作 */
                  .row-hover-actions {
                    .action-icon {
                      color: #8c8c8c !important;
                      &:hover {
                        color: #faad14 !important;
                      }
                      &.active {
                        color: #faad14 !important;
                      }
                    }

                    .group-select-btn {
                      color: #1890ff !important;
                      background: #e6f7ff !important;
                      border: 1px solid #91d5ff !important;

                      .btn-icon {
                        color: #1890ff !important;
                      }

                      &:hover {
                        color: #ffffff !important;
                        background: #1890ff !important;
                        border-color: #1890ff !important;
                        box-shadow: 0 2px 4px rgba(24, 144, 255, 0.25) !important;

                        .btn-icon {
                          color: #ffffff !important;
                        }
                      }

                      &.is-selected {
                        color: #1890ff !important;
                        background: #bae7ff !important;
                        border-color: #1890ff !important;
                        font-weight: 600 !important;
                      }
                    }
                  }
                }
              }
            }
          }

          /* 底部状态栏 */
          .tree-footer-bar {
            background: #fafafa !important;
            border-top: 1px solid #e8e8e8 !important;

            .footer-selection-info {
              .footer-label {
                color: #8c8c8c !important;
              }
              .footer-value {
                color: #1890ff !important;
                font-weight: 600 !important;
              }
            }

            .footer-locate-btn {
              color: #1890ff !important;
              &:hover {
                color: #40a9ff !important;
              }
            }
          }
        }
      }

      .resize-handle:hover {
        background: rgba(24, 144, 255, 0.3) !important;
      }
    }

    .show-trigger {
      background: #ffffff !important;
      border: 1px solid #d9d9d9 !important;
      border-left: none !important;
      color: #1890ff !important;
      box-shadow: 2px 0 6px rgba(0, 0, 0, 0.08) !important;

      &:hover {
        background: #1890ff !important;
        border-color: #1890ff !important;
        color: #ffffff !important;
        box-shadow: 0 0 8px rgba(24, 144, 255, 0.4) !important;
      }
    }
  }
  }
</style>

